import React from "react";
import { AdCard, AdSlotType } from '@insiderintelligence/googleadmanager';


export const GridAd: React.FC<{
  adSlotType: AdSlotType
}> = ({ adSlotType }) => {
  return (
    <div className="flex items-center justify-center">
      <AdCard adSlotType={adSlotType} className="w-auto h-grid-banner" />
    </div>
  );
};
